export default __webpack_public_path__ + "static/media/odometer.5d472985.svg";